import './Loader.css';
const Loader = () =>{
    return (
        <div className='loader-gif'>
            <img src="/assets/loading.gif" alt="loading..." />
        </div>
    );
}

export default Loader;